<template>
  <div id="widget-partners">
    <partners :options="parseOptions(options)" />
  </div>
</template>
<script>
import Partners from './Partners.vue'
export default {
  name: 'App',
  components: {
    Partners
  },
  props: {
    options: { default: null },
  },
  methods: {
    parseOptions(options) {
      console.log(options);
      try {
        return JSON.parse(options);
      } catch (e) {
        console.log(e);
        return null;
      }
    }
  }
}
</script>
